import React, { Component } from "react";
//PrimeReact Components
import * as pr from "../../common/PrimeComponents";
//Common
import { LoadScreen } from "../../common/LoadScreen";
import { api } from "../../common/ApiPromisify";
import * as format from "../../common/FormatFunctions"
//ClientLibsReference
import { Belfastpilatesappspotcom } from "../../common/ClientLibsReference";

export class ManageSetsArchive extends Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
      instructorList: "",
      setList: [],
      setSelected: false,
      selectedSet: "",
      selectedSetId: "",
      selectedSetServiceId: "",
      selectedSetLastUpdatedDateTime: "",
      selectedSetTitle: "",
      selectedSetLevel: "",
      selectedSetMaxNumberOfParticipants: "",
      selectedSetNumberOfParticipants: "",
      selectedSetStatus: "",
      selectedSetNextClass: "",
      selectedSetRoom: "",
      selectedSetRoomName: "",
      selectedSetCost: "",
      selectedSetInstructors: "",
      selectedSetInstructorNames: "",
      selectedSetClients: "",
      selectedSetClientNames: "",
      selectedSetBookList: [],
      selectedSetCompleteBookedListUserDetails: [],
      selectedSetStartDateDisplayString: "",
      selectedSetEndDateDisplayString: "",
      selectedSetMondayTime: [],
      selectedSetMondayStart: "",
      selectedSetMondayEnd: "",
      selectedSetTuesdayTime: [],
      selectedSetTuesdayStart: "",
      selectedSetTuesdayEnd: "",
      selectedSetWednesdayTime: [],
      selectedSetWednesdayStart: "",
      selectedSetWednesdayEnd: "",
      selectedSetThursdayTime: [],
      selectedSetFridayTime: [],
      selectedSetFridayStart: "",
      selectedSetFridayEnd: "",
      selectedSetSaturdayTime: [],
      selectedSetSaturdayStart: "",
      selectedSetSaturdayEnd: "",
      selectedSetSundayTime: [],
      selectedSetSundayStart: "",
      selectedSetSundayEnd: "",
      setEdited: false,
      editSet: "",
      editSetTitle: "",
      editSetLevel: "",
      editSetMaxNumberOfPartcipants: "",
      editSetStatus: "",
      editSetNextClass: "",
      editSetRoom: "",
      editSetRoomName: "",
      editSetCost: "",
      editSetInstructors: "",
      editSetInstructorNames: "",
      pickListAvailable: [],
      pickListSelected: [],
      clientList: [],
      clientOptions: [],
      selectedClient: "",
      clientUserId: "",
      deleteDialog: false,
      roomList: [],
      roomOptions: [],
      selectedPaidOnClick: "",
      selectedPaymentMethodOnClick: ""
    };

    // this.updateClientsBooksForSet = this.updateClientsBooksForSet.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
  }

  componentDidMount = async () => {
    this.getRooms();
    this.getClients();
    this.getInstructors();
  };

  getRooms = async () => {
    let roomRequest = new Belfastpilatesappspotcom.RoomRequest();
    roomRequest.codeTag = localStorage.getItem("globalBid");
    roomRequest.userId = localStorage.getItem("userId");

    await api("roomApiV1RoomGetByCodeTag", roomRequest).then(res => {
      if (res.data) {
        if (Array.isArray(res.data.roomList)) {
          res.data.roomList.forEach(e => {
            if (e.lastUpdatedDateTime) {
              e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
            }
          });
        }

        let roomResponse = Belfastpilatesappspotcom.RoomResponse.constructFromObject(
          res.data
        );
        console.log(roomResponse);

        if (roomResponse.errorCode === 0) {
          this.setState({ roomList: roomResponse.roomList }, () => {
            this.roomsToOptions();
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Rooms could not be retrieved, please refresh and try again",
            life: 3000
          });
        }
      } else {
        console.log("roomApiV1RoomGetByCodeTag has failed");
      }
    });
  };

  roomsToOptions = () => {
    let roomArray = [];

    if (Array.isArray(this.state.roomList)) {
      this.state.roomList.forEach(e => {
        roomArray.push({ label: e.name, value: e.id });
      });
    }

    this.setState({ roomOptions: roomArray });
  };

  getClients = async () => {
    let userRequest = new Belfastpilatesappspotcom.UserRequest();
    userRequest.codeTag = localStorage.getItem("globalBid");
    userRequest.roleType = 30;

    await api("userApiV1UserListByRoleType", userRequest).then(res => {
      if (res.data) {
        if (Array.isArray(res.data.users)) {
          res.data.users.forEach(e => {
            if (e.lastUpdatedDateTime) {
              e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
            }
          });
        }

        let userResponse = Belfastpilatesappspotcom.UserResponse.constructFromObject(
          res.data
        );
        console.log(userResponse);

        if (userResponse.errorCode === 0) {
          this.setState({
            clientList: userResponse.users
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Clients could not be retrieved, please refresh and try again",
            life: 3000
          });
        }
      } else {
        console.log("userApiV1UserListByRoleType has failed");
      }
    });
  };

  clientsToOptions = () => {
    let that = this;
    let clientArray = [];

    if (Array.isArray(this.state.clientList)) {
      this.state.clientList.forEach(e => {
        if (Array.isArray(e.level)) {
          e.level.forEach(f => {
            if (f === that.state.selectedSetLevel) {
              clientArray.push({
                label: e.firstName + " " + e.surname,
                value: e.id
              });
            }
          });
        }
      });
    }

    this.setState({ clientOptions: clientArray });
  };

  getInstructors = async () => {
    let userRequest = new Belfastpilatesappspotcom.UserRequest();
    userRequest.codeTag = localStorage.getItem("globalBid");

    await api("userApiV1UserListInBusiness", userRequest).then(res => {
      if (res.data) {
        if (res.data.lastUpdatedDateTime) {
          res.data.lastUpdatedDateTime = res.data.lastUpdatedDateTime.toJSON();
        }

        let userResponse = Belfastpilatesappspotcom.UserResponse.constructFromObject(
          res.data
        );
        console.log(userResponse);

        if (userResponse.errorCode === 0) {
          this.setState({
            instructorList: userResponse.users,
            pickListAvailable: userResponse.users,
            loaded: true
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Instructors could not be retrieved, please refresh and try again",
            life: 3000
          });
        }
      } else {
        console.log("userApiV1UserListInBusiness has failed");
      }
    });
  };

  getSetsByCodeTagAndDates = async () => {
    this.setState({ loaded: false });

    let setRequest = new Belfastpilatesappspotcom.SetRequest();
    setRequest.codeTag = localStorage.getItem("globalBid");
    setRequest.userId = localStorage.getItem("userId");
    setRequest.bookIdentifier = "CREATE";
    setRequest.fromDate = this.state.fromDate;
    setRequest.toDate = this.state.toDate;

    await api("setApiV1SetGetByCodeTagAndDates", setRequest).then(res => {
      if (res.data) {
        if (Array.isArray(res.data.setList)) {
          res.data.setList.forEach(e => {
            if (e.lastUpdatedDateTime) {
              e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
            }
            if (e.startDate) {
              e.startDate = e.startDate.toJSON();
            }
            if (e.endDate) {
              e.endDate = e.endDate.toJSON();
            }
          });
        }

        let setResponse = Belfastpilatesappspotcom.SetResponse.constructFromObject(
          res.data
        );
        console.log(setResponse);

        if (setResponse.errorCode === 0) {
          this.setState(
            {
              setList: setResponse.setList
            },
            async () => {
              if (Array.isArray(this.state.setList)) {
                this.state.setList.forEach(e => {
                  if (e.id === localStorage.getItem("selectedSetId")) {
                    this.setState({ selectedSet: e });
                    localStorage.removeItem("selectedSetId");
                  }
                });

                this.setState({ setSelected: false, setEdited: false });
              }
            }
          );
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "Sets could not be retrieved, please refresh and try again",
            life: 3000
          });
        }
      } else {
        console.log("setApiV1SetGetByCodeTagAndDates has failed");
      }
    });

    this.setState({ loaded: true });
  };

  setsToCard = () => {
    let setArray = [];
    let i = 0;
    let instructorNamesArray = [];
    let i2 = 0;
    let clientNamesArray = [];
    let i3 = 0;

    if (Array.isArray(this.state.setList)) {
      this.state.setList.forEach(e => {
        let roomName = "";
        if (Array.isArray(this.state.roomList)) {
          this.state.roomList.forEach(r => {
            if (r.id === e.roomId) {
              roomName = r.name;
            }
          });
        }

        setArray[i] = (
          <div
            key={i}
            id={i}
            className="card"
            onMouseOver={f => {
              f.currentTarget.style.boxShadow = "5px 5px 10px grey";
            }}
            onMouseOut={f => {
              f.currentTarget.style.boxShadow = "";
            }}
            onClick={g => {
              let element = document.getElementById(
                localStorage.getItem("manageSetsLastSelectedCardId")
              );
              if (element) {
                element.style.backgroundColor = "white";
              }
              g.currentTarget.style.backgroundColor = "#F44336";
              localStorage.setItem(
                "manageSetsLastSelectedCardId",
                g.currentTarget.id
              );

              if (Array.isArray(e.instructorDetails)) {
                e.instructorDetails.forEach(f => {
                  instructorNamesArray[i2] = (
                    <li key={i2}>{f.firstName + " " + f.surname}</li>
                  );
                  i2++;
                });
              }

              if (Array.isArray(e.bookedUserDetails)) {
                e.bookedUserDetails.forEach(f => {
                  clientNamesArray[i3] = (
                    <li key={i3}>{f.firstName + " " + f.surname}</li>
                  );
                  i3++;
                });
              }

              if (Array.isArray(e.data.completeBookedListUserDetails)) {
                e.data.completeBookedListUserDetails.forEach(f => {
                  f.multipleSets = "No"
                  if(format.isNotNull(this.state.multipleSetUsers)){
                    this.state.multipleSetUsers.forEach((g)=>{
                      if(f.userId === g){
                        f.multipleSets = "Yes"
                      }
                  });
                  }
                });
              }

              this.setState(
                {
                  setEdited: false,
                  setSelected: true,
                  selectedSet: e,
                  selectedSetId: e.id,
                  selectedSetServiceId: e.serviceId,
                  selectedSetLastUpdatedDateTime: e.lastUpdatedDateTime,
                  selectedSetTitle: e.title,
                  selectedSetLevel: e.level,
                  selectedSetMaxNumberOfParticipants: e.maxSpace,
                  selectedSetNumberOfParticipants: e.currentNumberOfUsers,
                  selectedSetStatus: e.status,
                  selectedSetRoom: e.roomId,
                  selectedSetRoomName: roomName,
                  selectedSetCost: e.cost,
                  selectedSetInstructors: e.instructorDetails,
                  selectedSetInstructorNames: instructorNamesArray,
                  selectedSetClients: e.bookedUserDetails,
                  selectedSetClientNames: clientNamesArray,
                  selectedSetBookList: e.bookList,
                  selectedSetCompleteBookedListUserDetails:
                    e.completeBookedListUserDetails,
                  pickListSelected: e.instructorDetails
                },
                () => {
                  console.log(this.state.selectedSet);
                  this.clientsToOptions();
                  this.getNextClass(e.id);

                  window.scrollTo({ top: 0, behavior: "smooth" });

                  if (this.state.pickListSelected) {
                    this.removePickListDuplicates();
                  }
                }
              );
            }}
            style={{
              cursor: "pointer"
            }}
          >
            <div className="ui-g" style={{ textAlign: "center" }}>
              <div className="ui-g-12 ui-md-3" style={{ textAlign: "left" }}>
                <br />
                <h1>{e.title || "No Title Set"}</h1>
              </div>
              <div className="ui-g-12 ui-md-3">
                <br />
                <h1>{e.status || "No Status Set"}</h1>
              </div>
              <div className="ui-g-12 ui-md-2">
                <br />
                <h1>{"£" + e.costToDisplay}</h1>
              </div>
              <div className="ui-g-12 ui-md-2">
                <h1>{e.startDateDisplayString || "No Start Date Set"}</h1>
                <h2>to</h2>
                <h1>{e.endDateDisplayString || "No End Date Set"}</h1>
              </div>
              <div className="ui-g-12 ui-md-2">
                <h1>
                  {"No. Booked: " + (e.currentNumberOfUsers || "No Bookings")}
                </h1>
                <h2>&nbsp;</h2>
                <h1>{"Max Space: " + (e.maxSpace || "No Max Space Set")}</h1>
              </div>
            </div>
          </div>
        );
        i++;
      });
    }

    return setArray;
  };

  removePickListDuplicates = () => {
    let i = 0;

    if (
      Array.isArray(this.state.pickListAvailable) &&
      Array.isArray(this.state.pickListSelected)
    )
      this.state.pickListAvailable.forEach(e => {
        this.state.pickListSelected.forEach(f => {
          if (e.id === f.id) {
            let pickListAvailable = this.state.pickListAvailable;
            pickListAvailable.splice(i, 1);
            this.setState({ pickListAvailable: pickListAvailable });
            i--;
          }
        });
        i++;
      });
  };

  getNextClass = async setId => {
    let bookRequest = new Belfastpilatesappspotcom.BookRequest();
    bookRequest.codeTag = localStorage.getItem("globalBid");
    bookRequest.userId = localStorage.getItem("userId");
    bookRequest.setId = setId;

    await api("bookApiV1BookGetNextBookingForSets", bookRequest).then(res => {
      if (res.data) {
        let bookResponse = Belfastpilatesappspotcom.BookResponse.constructFromObject(
          res.data
        );
        console.log(bookResponse);

        if (bookResponse.errorCode === 0) {
          if (bookResponse.bookList[0]) {
            this.setState({
              selectedSetNextClass: bookResponse.bookList[0].dateToDisplay
            });
          }
          if (bookResponse.bookList[0].buildingBean) {
            this.setState({
              selectedSetRoomName: bookResponse.bookList[0].buildingBean.name
            });
          }
        } else if (bookResponse.errorCode === 20880) {
          this.setState({
            selectedSetNextClass: "No next class"
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail:
              "Next class could not be retrieved, please refresh and try again",
            life: 3000
          });
        }
      } else {
        console.log("bookApiV1BookGetNextBookingForSets has failed");
      }
    });
  };

  closeDialog = () => {
    this.setState({
      displayDialog: false
    });
  };

  checkRequiredFieldsRetrieveSets = () =>{
    let disabled = true;
    if(format.isNotNull(this.state.fromDate) && format.isNotNull(this.state.toDate)){
        disabled = false;
    }
    console.log("From date: "+this.state.fromDate);
    console.log("From date: "+this.state.toDate);
    return disabled;
  }

  render() {
    if (!this.state.loaded) {
      return (
        <center>
          <pr.Growl
            style={{ textAlign: "left" }}
            ref={el => (this.growl = el)}
          />
          <LoadScreen />
        </center>
      );
    }
    return (
      <div className="ui-g">
        <pr.Growl style={{ textAlign: "left" }} ref={el => (this.growl = el)} />
        <div className="ui-g-12">
          <pr.Button
            label="Manage Sets"
            onClick={() => {
              window.location = "#/managesets";
            }}
            style={{ float: "right" }}
          />
        </div>
        <div className="ui-g-12 card">
                <div className="ui-g-12">
                Select Date range to return Sets
                </div>
               
            <div className="ui-g-6 ui-g-nopad">
            <div className="ui-g-2">
                <label>From Date: </label>
            </div>
                <div className="ui-g-10">
                    <pr.Calendar
                      value={this.state.fromDate}
                      onChange={e => this.setState({ fromDate: e.value })}
                      dateFormat="dd/mm/yy"
                    />
                </div>
            </div>
            <div className="ui-g-6 ui-g-nopad">
            <div className="ui-g-2">
                <label>To Date: </label>
            </div>
                <div className="ui-g-10">
                    <pr.Calendar
                      value={this.state.toDate}
                      onChange={e => this.setState({ toDate: e.value })}
                      dateFormat="dd/mm/yy"
                    />
                </div>
            </div>
            <pr.Button
                    label={"Retrieve Sets"}
                    onClick={() => {
                      this.setState({ loaded: false });
                      this.getSetsByCodeTagAndDates();
                    }}
                    style={{ float: "right" }}
                    disabled={this.checkRequiredFieldsRetrieveSets()}
                  />
        </div>
        <div className="ui-g-12">

          {!this.state.setSelected ? (
            <label />
          ) : (
            <div className="card">
              <div className="ui-g">
                <div className="ui-g-12">
                  {/* <pr.Button
                    className="secondary-btn"
                    icon="pi pi-pencil"
                    onClick={() => {
                      this.setState(
                        {
                          setSelected: false,
                          setEdited: true,
                          editSet: this.state.selectedSet,
                          editSetTitle: this.state.selectedSetTitle,
                          editSetLevel: this.state.selectedSetLevel,
                          editSetMaxNumberOfPartcipants: this.state
                            .selectedSetMaxNumberOfParticipants,
                          editSetStatus: this.state.selectedSetStatus,
                          editSetRoom: this.state.selectedSetRoom,
                          editSetNextClass: this.state.selectedSetNextClass,
                          editSetRoomName: this.state.selectedSetRoomName,
                          editSetCost: this.state.selectedSetCost / 100,
                          editSetInstructors: this.state.selectedSetInstructors,
                          editSetInstructorNames: this.state
                            .selectedSetInstructorNames
                        },
                        () => {
                          if (Array.isArray(this.state.selectedSetMondayTime)) {
                            this.setState({
                              selectedSetMondayStart: this.state
                                .selectedSetMondayTime[0],
                              selectedSetMondayEnd: this.state
                                .selectedSetMondayTime[1]
                            });
                          }
                          if (
                            Array.isArray(this.state.selectedSetTuesdayTime)
                          ) {
                            this.setState({
                              selectedSetTuesdayStart: this.state
                                .selectedSetTuesdayTime[0],
                              selectedSetTuesdayEnd: this.state
                                .selectedSetTuesdayTime[1]
                            });
                          }
                          if (
                            Array.isArray(this.state.selectedSetWednesdayTime)
                          ) {
                            this.setState({
                              selectedSetWednesdayStart: this.state
                                .selectedSetWednesdayTime[0],
                              selectedSetWednesdayEnd: this.state
                                .selectedSetWednesdayTime[1]
                            });
                          }
                          if (
                            Array.isArray(this.state.selectedSetThursdayTime)
                          ) {
                            this.setState({
                              selectedSetThursdayStart: this.state
                                .selectedSetThursdayTime[0],
                              selectedSetThursdayEnd: this.state
                                .selectedSetThursdayTime[1]
                            });
                          }
                          if (Array.isArray(this.state.selectedSetFridayTime)) {
                            this.setState({
                              selectedSetFridayStart: this.state
                                .selectedSetFridayTime[0],
                              selectedSetFridayEnd: this.state
                                .selectedSetFridayTime[1]
                            });
                          }
                          if (
                            Array.isArray(this.state.selectedSetSaturdayTime)
                          ) {
                            this.setState({
                              selectedSetSaturdayStart: this.state
                                .selectedSetSaturdayTime[0],
                              selectedSetSaturdayEnd: this.state
                                .selectedSetSaturdayTime[1]
                            });
                          }
                          if (Array.isArray(this.state.selectedSetSundayTime)) {
                            this.setState({
                              selectedSetSundayStart: this.state
                                .selectedSetSundayTime[0],
                              selectedSetSundayEnd: this.state
                                .selectedSetSundayTime[1]
                            });
                          }
                        }
                      );
                    }}
                    style={{ float: "right" }}
                  /> */}
                </div>
                <div className="ui-g-6 ui-g-nopad">
                  <div className="ui-g-12">
                    <b>Title: </b>
                    <label>{this.state.selectedSetTitle || "Not Set"}</label>
                  </div>
                  <div className="ui-g-12">
                    <b>Level: </b>
                    <b
                      style={
                        this.state.selectedSetLevel === "Beginner/Progressive"
                          ? {
                              background: "#3f51b5",
                              color: "white",
                              borderStyle: "solid",
                              borderColor: "black"
                            }
                          : this.state.selectedSetLevel ===
                            "Progressive/Intermediate"
                          ? {
                              background: "#4caf50",
                              color: "white",
                              borderStyle: "solid",
                              borderColor: "black"
                            }
                          : this.state.selectedSetLevel ===
                            "Intermediate/Advanced"
                          ? {
                              background: "#f44336",
                              color: "white",
                              borderStyle: "solid",
                              borderColor: "black"
                            }
                          : this.state.selectedSetLevel === "Reformer"
                          ? {
                              background: "#e91e63",
                              color: "white",
                              borderStyle: "solid",
                              borderColor: "black"
                            }
                          : this.state.selectedSetLevel === "Mum and Baby"
                          ? {
                              background: "#ffc107",
                              color: "white",
                              borderStyle: "solid",
                              borderColor: "black"
                            }
                          : this.state.selectedSetLevel === "Antenatal"
                          ? {
                              background: "#ff9800",
                              color: "white",
                              borderStyle: "solid",
                              borderColor: "black"
                            }
                          : this.state.selectedSetLevel === "Kids"
                          ? {
                              background: "#00bcd4",
                              color: "white",
                              borderStyle: "solid",
                              borderColor: "black"
                            }
                          : {
                              background: "red",
                              color: "white",
                              borderStyle: "solid",
                              borderColor: "black"
                            }
                      }
                    >
                      {this.state.selectedSetLevel || "Not Set"}
                    </b>
                  </div>
                  <div className="ui-g-12">
                    <b>Max Number of Participants: </b>
                    <label>
                      {this.state.selectedSetMaxNumberOfParticipants || "0"}
                    </label>
                  </div>
                  <div className="ui-g-12">
                    <b>Number of Participants: </b>
                    <label>
                      {this.state.selectedSetNumberOfParticipants || "0"}
                    </label>
                  </div>
                  <div className="ui-g-12">
                    <b>Status: </b>
                    <label>{this.state.selectedSetStatus || "Not Set"}</label>
                  </div>
                  <div className="ui-g-12">
                    <b>Room: </b>
                    <label>{this.state.selectedSetRoomName || "Not Set"}</label>
                  </div>
                  <div className="ui-g-12">
                    <b>Start Date: </b>
                    <label>
                      {this.state.selectedSetStartDateDisplayString ||
                        "Not Set"}
                    </label>
                  </div>
                  <div className="ui-g-12">
                    <b>End Date: </b>
                    <label>
                      {this.state.selectedSetEndDateDisplayString || "Not Set"}
                    </label>
                  </div>
                  <div className="ui-g-12">
                    <b>Next Class: </b>
                    <label>
                      {this.state.selectedSetNextClass || "Not Set"}
                    </label>
                  </div>
                  {this.state.selectedSetMondayTime ? (
                    <div className="ui-g-12">
                      <b>Monday: </b>
                      <label>
                        {Array.isArray(this.state.selectedSetMondayTime)
                          ? this.state.selectedSetMondayTime
                              .toString()
                              .replace(",", ", ")
                          : "Not Set"}
                      </label>
                    </div>
                  ) : (
                    <label />
                  )}
                  {this.state.selectedSetTuesdayTime ? (
                    <div className="ui-g-12">
                      <b>Tuesday: </b>
                      <label>
                        {Array.isArray(this.state.selectedSetTuesdayTime)
                          ? this.state.selectedSetTuesdayTime
                              .toString()
                              .replace(",", ", ")
                          : "Not Set"}
                      </label>
                    </div>
                  ) : (
                    <label />
                  )}
                  {this.state.selectedSetWednesdayTime ? (
                    <div className="ui-g-12">
                      <b>Wednesday: </b>
                      <label>
                        {Array.isArray(this.state.selectedSetWednesdayTime)
                          ? this.state.selectedSetWednesdayTime
                              .toString()
                              .replace(",", ", ")
                          : "Not Set"}
                      </label>
                    </div>
                  ) : (
                    <label />
                  )}
                  {this.state.selectedSetThursdayTime ? (
                    <div className="ui-g-12">
                      <b>Thursday: </b>
                      <label>
                        {Array.isArray(this.state.selectedSetThursdayTime)
                          ? this.state.selectedSetThursdayTime
                              .toString()
                              .replace(",", ", ")
                          : "Not Set"}
                      </label>
                    </div>
                  ) : (
                    <label />
                  )}
                  {this.state.selectedSetFridayTime ? (
                    <div className="ui-g-12">
                      <b>Friday: </b>
                      <label>
                        {Array.isArray(this.state.selectedSetFridayTime)
                          ? this.state.selectedSetFridayTime
                              .toString()
                              .replace(",", ", ")
                          : "Not Set"}
                      </label>
                    </div>
                  ) : (
                    <label />
                  )}
                  {this.state.selectedSetSaturdayTime ? (
                    <div className="ui-g-12">
                      <b>Saturday: </b>
                      <label>
                        {Array.isArray(this.state.selectedSetSaturdayTime)
                          ? this.state.selectedSetSaturdayTime
                              .toString()
                              .replace(",", ", ")
                          : "Not Set"}
                      </label>
                    </div>
                  ) : (
                    <label />
                  )}
                  {this.state.selectedSetSundayTime ? (
                    <div className="ui-g-12">
                      <b>Sunday: </b>
                      <label>
                        {Array.isArray(this.state.selectedSetSundayTime)
                          ? this.state.selectedSetSundayTime
                              .toString()
                              .replace(",", ", ")
                          : "Not Set"}
                      </label>
                    </div>
                  ) : (
                    <label />
                  )}
                </div>
                <div className="ui-g-6">
                  <div className="ui-g-12">
                    <b>Price: </b>
                    <label>
                      {"£" + this.state.selectedSetCost / 100 || "Not Set"}
                    </label>
                  </div>
                  <div className="ui-g-12">
                    <b>Instructor(s): </b>
                    <ul>
                      {this.state.selectedSetInstructorNames.length === 0 ? (
                        <li>Not Set</li>
                      ) : (
                        this.state.selectedSetInstructorNames
                      )}
                    </ul>
                  </div>
                  <div className="ui-g-12">
                    <b>Client(s): </b>
                    <br />
                    <br />
                    <pr.DataTable
                      value={
                        this.state.selectedSetCompleteBookedListUserDetails
                      }
                      selectionMode="single"
                      onSelectionChange={() => {}}
                      header=" "
                      footer=" "
                      autoLayout={true}
                      paginator={false}
                      alwaysShowPaginator={false}
                      scrollable={true}
                    >
                      <pr.Column
                        field="bookedUserDetails.firstName"
                        header="First Name"
                        body={e => {
                          if (
                            e.bookedUserDetails &&
                            e.bookedUserDetails.length
                          ) {
                            return e.bookedUserDetails[0].firstName;
                          }
                        }}
                        sortable={false}
                        filter={false}
                        style={{ overflow: "auto" }}
                      />
                      <pr.Column
                        field="bookedUserDetails.surname"
                        header="Surname"
                        body={e => {
                          if (
                            e.bookedUserDetails &&
                            e.bookedUserDetails.length
                          ) {
                            return e.bookedUserDetails[0].surname;
                          }
                        }}
                        sortable={false}
                        filter={false}
                        style={{ overflow: "auto" }}
                      />
                      <pr.Column
                        field="paid"
                        header="Paid?"
                        body={e => {
                          if (e.paid) {
                            return "Yes";
                          } else {
                            return "No";
                          }
                        }}
                        sortable={false}
                        filter={false}
                        style={{ overflow: "auto" }}
                      />
                      <pr.Column
                        field="paymentMethod"
                        header="Payment Method"
                        sortable={true}
                        filter={true}
                        style={{ overflow: "auto" }}
                      />
                      {/* <pr.Column
                        field="multipleSets"
                        header="Multiple Sets"
                        sortable={true}
                        filter={true}
                        style={{ overflow: "auto" }}
                      /> */}
                    </pr.DataTable>
                  </div>
                </div>
                <div className="ui-g-12">
                  <pr.Button
                    label="Re-Create Set"
                    onClick={() => {
                      localStorage.setItem("reCreate", true);
                      localStorage.setItem(
                        "reCreateServiceId",
                        this.state.selectedSetServiceId
                      );
                      localStorage.setItem(
                        "reCreateSetId",
                        this.state.selectedSetId
                      );
                      localStorage.setItem(
                        "reCreateMaxParticipants",
                        this.state.selectedSetMaxNumberOfParticipants
                      );
                      localStorage.setItem(
                        "reCreateMondayTime",
                        this.state.selectedSetMondayTime
                      );
                      localStorage.setItem(
                        "reCreateTuesdayTime",
                        this.state.selectedSetTuesdayTime
                      );
                      localStorage.setItem(
                        "reCreateWednesdayTime",
                        this.state.selectedSetWednesdayTime
                      );
                      localStorage.setItem(
                        "reCreateThursdayTime",
                        this.state.selectedSetThursdayTime
                      );
                      localStorage.setItem(
                        "reCreateFridayTime",
                        this.state.selectedSetFridayTime
                      );
                      localStorage.setItem(
                        "reCreateSaturdayTime",
                        this.state.selectedSetSaturdayTime
                      );
                      localStorage.setItem(
                        "reCreateSundayTime",
                        this.state.selectedSetSundayTime
                      );
                      localStorage.setItem(
                        "reCreateRoomId",
                        this.state.selectedSetRoom
                      );
                      localStorage.setItem(
                        "reCreatePickedInstructors",
                        JSON.stringify(this.state.pickListSelected)
                      );
                      window.location = "#/createsets";
                    }}
                    style={{ float: "right" }}
                  />
                  <pr.Button
                    label="View Classes"
                    onClick={() => {
                      localStorage.setItem(
                        "selectedSetId",
                        this.state.selectedSetId
                      );
                      localStorage.setItem(
                        "selectedSetServiceId",
                        this.state.selectedSetServiceId
                      );
                      window.location = "#/classessets";
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            </div>
          )}

          <div className="ui-g card">
            <div className="ui-g-12">
              <pr.DataTable
                value={this.state.setList}
                selectionMode="single"
                selection={this.state.selectedSet}
                onSelectionChange={e => {
                  let instructorNamesArray = [];
                  let i2 = 0;
                  let clientNamesArray = [];
                  let i3 = 0;
                  let roomName = "";

                  if (Array.isArray(this.state.roomList)) {
                    this.state.roomList.forEach(r => {
                      if (r.id === e.data.roomId) {
                        roomName = r.name;
                      }
                    });
                  }

                  if (Array.isArray(e.data.instructorDetails)) {
                    e.data.instructorDetails.forEach(f => {
                      instructorNamesArray[i2] = (
                        <li key={i2}>{f.firstName + " " + f.surname}</li>
                      );
                      i2++;
                    });
                  }

                  if (Array.isArray(e.data.bookedUserDetails)) {
                    e.data.bookedUserDetails.forEach(f => {
                      clientNamesArray[i3] = (
                        <li key={i3}>{f.firstName + " " + f.surname}</li>
                      );
                      i3++;
                    });
                  }

                  if (Array.isArray(e.data.completeBookedListUserDetails)) {
                    e.data.completeBookedListUserDetails.forEach(f => {
                      f.multipleSets = "No"
                      if(format.isNotNull(this.state.multipleSetUsers)){
                        this.state.multipleSetUsers.forEach((g)=>{
                          if(f.userId === g){
                            f.multipleSets = "Yes"
                          }
                      });
                      }
                    });
                  }

                  this.setState(
                    {
                      setEdited: false,
                      setSelected: true,
                      selectedSet: e.data,
                      selectedSetId: e.data.id,
                      selectedSetServiceId: e.data.serviceId,
                      selectedSetLastUpdatedDateTime:
                        e.data.lastUpdatedDateTime,
                      selectedSetTitle: e.data.title,
                      selectedSetLevel: e.data.level,
                      selectedSetMaxNumberOfParticipants: e.data.maxSpace,
                      selectedSetNumberOfParticipants:
                        e.data.currentNumberOfUsers,
                      selectedSetStatus: e.data.status,
                      selectedSetRoom: e.data.roomId,
                      selectedSetRoomName: roomName,
                      selectedSetCost: e.data.cost,
                      selectedSetInstructors: e.data.instructorDetails,
                      selectedSetInstructorNames: instructorNamesArray,
                      selectedSetClients: e.data.bookedUserDetails,
                      selectedSetClientNames: clientNamesArray,
                      selectedSetBookList: e.data.bookList,
                      selectedSetCompleteBookedListUserDetails:
                        e.data.completeBookedListUserDetails,
                      pickListSelected: e.data.instructorDetails,
                      selectedSetStartDateDisplayString:
                        e.data.startDateDisplayString,
                      selectedSetEndDateDisplayString:
                        e.data.endDateDisplayString,
                      selectedSetMondayTime: e.data.mondayTime,
                      selectedSetTuesdayTime: e.data.tuesdayTime,
                      selectedSetWednesdayTime: e.data.wednesdayTime,
                      selectedSetThursdayTime: e.data.thursdayTime,
                      selectedSetFridayTime: e.data.fridayTime,
                      selectedSetSaturdayTime: e.data.saturdayTime,
                      selectedSetSundayTime: e.data.sundayTime
                    },
                    () => {
                      console.log(this.state.selectedSet);
                      this.clientsToOptions();
                      this.getNextClass(this.state.selectedSetId);

                      window.scrollTo({ top: 0, behavior: "smooth" });

                      if (this.state.pickListSelected) {
                        this.removePickListDuplicates();
                      }
                    }
                  );
                }}
                header="Sets"
                footer=" "
                autoLayout={true}
                paginator={false}
                alwaysShowPaginator={false}
                scrollable={true}
              >
                <pr.Column
                  field="title"
                  header="Title"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="level"
                  header="Level"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="instructorDetails"
                  header="Instructors"
                  body={e => {
                    let nameArray = [];
                    let i = 0;

                    if (Array.isArray(e.instructorDetails)) {
                      e.instructorDetails.forEach(f => {
                        nameArray.push(
                          <span key={i}>
                            {(f.firstName || "") + " " + (f.surname || "")}
                            <br />
                          </span>
                        );
                        i++;
                      });
                    }

                    return nameArray;
                  }}
                  sortable={false}
                  filter={false}
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="dayOfWeek"
                  header="Day of the Week"
                  body={e => {
                    let daysToDisplay = [];
                    let i = 0;

                    if (Array.isArray(e.dayOfWeek)) {
                      e.dayOfWeek.forEach(f => {
                        let num = parseInt(f, 10);
                        if (num === 1) {
                          daysToDisplay.push(
                            <span key={i}>
                              Monday
                              <br />
                            </span>
                          );
                        } else if (num === 2) {
                          daysToDisplay.push(
                            <span key={i}>
                              Tuesday
                              <br />
                            </span>
                          );
                        } else if (num === 3) {
                          daysToDisplay.push(
                            <span key={i}>
                              Wednesday
                              <br />
                            </span>
                          );
                        } else if (num === 4) {
                          daysToDisplay.push(
                            <span key={i}>
                              Thursday
                              <br />
                            </span>
                          );
                        } else if (num === 5) {
                          daysToDisplay.push(
                            <span key={i}>
                              Friday
                              <br />
                            </span>
                          );
                        } else if (num === 6) {
                          daysToDisplay.push(
                            <span key={i}>
                              Saturday
                              <br />
                            </span>
                          );
                        } else if (num === 7) {
                          daysToDisplay.push(
                            <span key={i}>
                              Sunday
                              <br />
                            </span>
                          );
                        } else {
                        }

                        i++;
                      });
                    }

                    return daysToDisplay;
                  }}
                  sortable={false}
                  filter={false}
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field=""
                  header="Start Time"
                  body={e => {
                    let timesToDisplay = [];
                    let i = 0;

                    if (Array.isArray(e.mondayTime)) {
                      timesToDisplay.push(
                        <span key={i}>
                          {e.mondayTime[0]}
                          <br />
                        </span>
                      );
                      i++;
                    }

                    if (Array.isArray(e.tuesdayTime)) {
                      timesToDisplay.push(
                        <span key={i}>
                          {e.tuesdayTime[0]}
                          <br />
                        </span>
                      );
                      i++;
                    }

                    if (Array.isArray(e.wednesdayTime)) {
                      timesToDisplay.push(
                        <span key={i}>
                          {e.wednesdayTime[0]}
                          <br />
                        </span>
                      );
                      i++;
                    }

                    if (Array.isArray(e.thursdayTime)) {
                      timesToDisplay.push(
                        <span key={i}>
                          {e.thursdayTime[0]}
                          <br />
                        </span>
                      );
                      i++;
                    }

                    if (Array.isArray(e.fridayTime)) {
                      timesToDisplay.push(
                        <span key={i}>
                          {e.fridayTime[0]}
                          <br />
                        </span>
                      );
                      i++;
                    }

                    if (Array.isArray(e.saturdayTime)) {
                      timesToDisplay.push(
                        <span key={i}>
                          {e.saturdayTime[0]}
                          <br />
                        </span>
                      );
                      i++;
                    }

                    if (Array.isArray(e.sundayTime)) {
                      timesToDisplay.push(
                        <span key={i}>
                          {e.sundayTime[0]}
                          <br />
                        </span>
                      );
                      i++;
                    }

                    return timesToDisplay;
                  }}
                  sortable={false}
                  filter={false}
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="maxSpace"
                  header="Max Spaces"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="currentNumberOfUsers"
                  header="Number Booked"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="roomId"
                  header="Room"
                  body={e => {
                    let roomName = "";

                    if (Array.isArray(this.state.roomList)) {
                      this.state.roomList.forEach(r => {
                        if (r.id === e.roomId) {
                          roomName = r.name;
                        }
                      });
                    }

                    return roomName;
                  }}
                  sortable={false}
                  filter={false}
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="status"
                  header="Status"
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="costToDisplay"
                  header="Price"
                  body={e => {
                    return "£" + e.costToDisplay;
                  }}
                  sortable={true}
                  filter={true}
                  style={{ overflow: "auto" }}
                />
              </pr.DataTable>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Sets/ManageSetsArchive.js